"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangePasswordRequestPayloadToJSON = exports.ChangePasswordRequestPayloadFromJSONTyped = exports.ChangePasswordRequestPayloadFromJSON = void 0;
var runtime_1 = require("../runtime");
function ChangePasswordRequestPayloadFromJSON(json) {
    return ChangePasswordRequestPayloadFromJSONTyped(json, false);
}
exports.ChangePasswordRequestPayloadFromJSON = ChangePasswordRequestPayloadFromJSON;
function ChangePasswordRequestPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'oldPassword': !(0, runtime_1.exists)(json, 'oldPassword') ? undefined : json['oldPassword'],
        'newPassword': json['newPassword'],
    };
}
exports.ChangePasswordRequestPayloadFromJSONTyped = ChangePasswordRequestPayloadFromJSONTyped;
function ChangePasswordRequestPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'oldPassword': value.oldPassword,
        'newPassword': value.newPassword,
    };
}
exports.ChangePasswordRequestPayloadToJSON = ChangePasswordRequestPayloadToJSON;
//# sourceMappingURL=ChangePasswordRequestPayload.js.map